export default __webpack_public_path__ + "static/media/pool-active.019fe036.svg";